import { EmptyStateContainer } from './EmptyStateContainer';

export default EmptyStateContainer;
